import React from "react";
import logo from "src/assets/images/loading.svg";

import styled, { css } from "styled-components";

export interface ILoadingProps {
  style?: React.CSSProperties;
  text?: boolean;
}

const StyledContainer = styled.div`
  ${() => {
    return css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 60vh;

      @keyframes prorotate {
        0% {
          transform: rotate(0);
        }

        100% {
          transform: rotate(720deg);
        }
      }

      .logo {
        animation: prorotate 3s ease-in-out infinite;
      }

      div {
        margin-top: 32px;
        color: #fff000;
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        text-align: center;
      }
    `;
  }}
`;
const Loading: React.FC<ILoadingProps> = ({ style, text }) => {
  return (
    <StyledContainer className="component_loading" style={style}>
      <img alt="loading" src={logo} className="logo" />
      {text && (
        <div style={{ color: "#fff" }}>
          !!Plase wait. Application is loading.
        </div>
      )}
    </StyledContainer>
  );
};

Loading.defaultProps = {
  text: true,
};

export default Loading;
